import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  LinearProgress,
  TextField,
  Typography
} from '@mui/material'
import { styled } from '@mui/material/styles'
import { Filter } from '../../../components/_WMS/FilterComponent'
import React, { Fragment, useState } from 'react'
import { useApi } from '../../../hooks/useApi'
import { Loading } from '../../../components/UI/Loading/Loading'
import { Status } from '../../../hooks/useFetchState'
import { getWorkOrderRecallTemplate, postWorkOrderRecall } from '../api'
import { WarehouseDDL } from '../../../components/Almacen'
import { ZoneDDL } from '../../../components/Zone'
import { ProductOriginsDDL } from '../../../components/Producto/ProductOrigins/ProductOriginsDDL'
import { HelpIcon } from '../../../components/_WMS/HelpIcon/HelpIcon'
import { eTypeStorage } from '../../../enums/eTypeStorage'
import { Download as DownloadIcon } from '@mui/icons-material'
import FileUploadIcon from '@mui/icons-material/FileUpload';

const BorderLinearProgress = styled(LinearProgress)({
  height: 15,
  borderRadius: 5,
  backgroundColor: '#EEEEEE',
  '& .MuiLinearProgress-bar': {
    borderRadius: 5,
    backgroundColor: '#1a90ff'
  }
})

const SectionNumber = ({ number }: { number: number }) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: 24,
      height: 24,
      borderRadius: '50%',
      border: '2px solid #004bb1',
      color: '#004bb1',
      fontWeight: 'bold',
      marginRight: 1.5,
      flexShrink: 0,
      fontSize: '0.8rem'
    }}
  >
    {number}
  </Box>
)

interface CreateWorkOrderRecallModalProps {
  handleSnackbar: (message: string, success: boolean) => void
  handleCloseModal: () => void
  requestWorkOrderRecall: (
    filters?: Filter[],
    page?: number,
    pageSize?: number
  ) => void
}

export const CreateWorkOrderRecallModal: React.FC<
  CreateWorkOrderRecallModalProps
> = ({ handleSnackbar, handleCloseModal, requestWorkOrderRecall }) => {
  const [currentFile] = useState<any | undefined>(undefined)
  const [progress, setProgress] = useState<number>(0)

  const [selectedFiles, setSelectedFiles] = useState<any[] | undefined>(
    undefined
  )

  const [promiseDate, setpromiseDate] = useState<string>('')
  const [promiseDateError, setPromiseDateError] = useState<string>(
    'La fecha compromiso es obligatoria'
  )
  const [comments, setComments] = useState<string>('')
  const [checkQuality, setCheckQuality] = useState(false)
  const [loading, setLoading] = useState<boolean>(false)
  const [checkTotalSku, setCheckTotalSku] = useState(false)

  const { state: requestLabelState, callApi: requestDownloadTemplate } =
    useApi()
  const [selectedWarehouse, setSelectedWarehouse] = useState<number>(-1)
  const [selectedProductOrigins, setSelectedProductOrigins] =
    useState<number>(0)
  const [selectedZone, setSelectedZone] = useState<number>(-1)
  // const [zonesByWarehouse, setZonesByWarehouse] = useState<Zone[]>([])
  // Obtener la fecha de hoy en formato YYYY-MM-DD
  const today = new Date().toISOString().split('T')[0]
  const { state, callApi } = useApi()

  const handleSetProductOrigin = (id: number) => {
    setSelectedProductOrigins(id)
    setSelectedWarehouse(-1)
    setSelectedZone(-1)
  }

  const handleSetZone = (id: number) => {
    setSelectedZone(id)
  }

  const handleSetWarehouse = (id: number) => {
    setSelectedWarehouse(id)
    setSelectedZone(-1)
  }

  const handleChkQuality = () => {
    setCheckQuality(!checkQuality)
  }

  const handleChkTotalSku = () => {
    setCheckTotalSku(!checkTotalSku)
  }

  const handleDatePickerChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setpromiseDate(e.target.value)
    if (!e.target.value) {
      setPromiseDateError('La fecha compromiso es obligatoria')
    } else if (e.target.value < today) {
      setPromiseDateError('La fecha no puede ser menor a la fecha actual')
    } else {
      setPromiseDateError('')
    }
  }

  const handleCommentsChange = ({
    target: { value: userComments }
  }: React.ChangeEvent<HTMLInputElement>) => {
    setComments(userComments)
  }

  const handleSelectFile = (event: any) => {
    setSelectedFiles(event.target.files)
    setProgress(0)
  }

  const validateButtonLoad = () => {
    if (
      !selectedFiles ||
      selectedWarehouse <= 0 ||
      selectedZone <= 0 ||
      !promiseDate
    )
      return true
    else return false
  }

  const handleSubmit = () => {
    setLoading(true)

    const formData = new FormData()

    // Agregar los valores del formulario
    formData.append('productOriginId', `${selectedProductOrigins}`)
    formData.append('promiseDate', promiseDate)
    formData.append('zoneId', `${selectedZone}`)
    formData.append('isTotalSku', `${checkTotalSku}`)
    formData.append('isQualityControl', `${checkQuality}`)
    formData.append('comments', `${comments}`)

    // Agregar el archivo seleccionado
    if (selectedFiles && selectedFiles.length > 0)
      formData.append('file', selectedFiles[0])

    callApi(postWorkOrderRecall(formData))
      .then(() => {
        handleSnackbar('Carga realizada exitosamente', true)
        requestWorkOrderRecall()
        handleCloseModal()
      })
      .catch((error) => {
        handleSnackbar(error, false)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  const handleDownloadTemplate = () => {
    setLoading(true)

    requestDownloadTemplate(getWorkOrderRecallTemplate())
      .then((response) => {
        const raw = window.atob(response.file)
        const uInt8Array = new Uint8Array(raw.length)
        for (let i = 0; i < raw.length; ++i) {
          uInt8Array[i] = raw.charCodeAt(i)
        }
        const link = document.createElement('a')
        const blob = new Blob([uInt8Array], {
          type: response.mimeType
        })
        link.style.display = 'none'
        link.href = URL.createObjectURL(blob)
        link.setAttribute('download', response.name)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      })
      .catch((error) => {
        handleSnackbar(error, false)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  if (state.status === Status.Loading || loading) {
    return (
      <Box display='flex' justifyContent='center' p={3}>
        <Loading />
      </Box>
    )
  }

  return (
    <Fragment>
      <Box sx={{ pb: 1 }}>
        {/* Descripción */}
        <Typography variant='body2' color='textSecondary' sx={{ mb: 1 }}>
          Completa los datos y carga el archivo con los productos y cantidades a retirar del almacén.
        </Typography>

        {/* Sección 1: Datos de la orden */}
        <Box sx={{ mb: 1 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
            <SectionNumber number={1} />
            <Typography variant='subtitle1' sx={{ color: '#004bb1', fontWeight: 'bold', fontSize: '0.95rem' }}>
              Datos de la orden
            </Typography>
          </Box>
          <Grid container spacing={2} sx={{ pl: 6 }}>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                id='promiseDate'
                name='promiseDate'
                label='Fecha de Compromiso *'
                type='date'
                value={promiseDate}
                onChange={handleDatePickerChange}
                variant='outlined'
                size='small'
                error={!!promiseDateError}
                helperText={promiseDateError}
                inputProps={{
                  min: today
                }}
                InputLabelProps={{
                  shrink: true
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <ProductOriginsDDL
                onChange={(e: any) =>
                  handleSetProductOrigin(e.target.value as number)
                }
                value={selectedProductOrigins}
                required={true}
                type='outlined'
                fullWidth
                size='small'
                label='Marca *'
                typeStorages={[eTypeStorage.Interno, eTypeStorage.Mixto]}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <WarehouseDDL
                onChange={(e: any) =>
                  handleSetWarehouse(e.target.value as number)
                }
                value={selectedWarehouse}
                productOriginId={selectedProductOrigins}
                required={true}
                type='outlined'
                fullWidth
                size='small'
                label='Almacén *'
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Box sx={{ display: 'flex', gap: 1, width: '100%' }}>
                <Box sx={{ flex: 1 }}>
                  <ZoneDDL
                    value={selectedZone}
                    onChange={(e: any) => handleSetZone(e.target.value as number)}
                    warehouseId={selectedWarehouse}
                    required={true}
                    disabled={selectedWarehouse === -1}
                    variant='outlined'
                    fullWidth
                    size='small'
                    isExternal={false}
                    label='Zona *'
                  />
                </Box>
                <HelpIcon
                  helperText='No se muestran zonas configuradas como externas'
                  placement='bottom-end'
                />
              </Box>
            </Grid>
          </Grid>
        </Box>
        <Box sx={{ borderBottom: '1px solid #e0e0e0', mb: 2 }} />

        {/* Sección 2: Opciones */}
        <Box sx={{ mb: 1 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
            <SectionNumber number={2} />
            <Typography variant='subtitle1' sx={{ color: '#004bb1', fontWeight: 'bold', fontSize: '0.95rem' }}>
              Opciones
            </Typography>
          </Box>
          <Grid container spacing={1} sx={{ pl: 6 }}>
            <Grid item xs={12} sm={6}>
              <FormControlLabel
                control={
                  <Checkbox
                    size='medium'
                    color='primary'
                    onChange={() => handleChkQuality()}
                    checked={checkQuality}
                  />
                }
                label='Control de Calidad'
              />
              <Typography variant='caption' color='textSecondary' display='block'>
                Asegura una revisión antes de la salida de los productos
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControlLabel
                control={
                  <Checkbox
                    size='medium'
                    color='primary'
                    onChange={() => handleChkTotalSku()}
                    checked={checkTotalSku}
                  />
                }
                label='Totalidad de Productos'
              />
              <Typography variant='caption' color='textSecondary' display='block'>
                Retiro total de stock de los productos incluidos en el archivo
              </Typography>
            </Grid>
          </Grid>
        </Box>
        <Box sx={{ borderBottom: '1px solid #e0e0e0', mb: 2 }} />

        {/* Sección 3: Comentarios */}
        <Box sx={{ mb: 1 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
            <SectionNumber number={3} />
            <Typography variant='subtitle1' sx={{ color: '#004bb1', fontWeight: 'bold', fontSize: '0.95rem' }}>
              Comentarios
            </Typography>
          </Box>
          <Box sx={{ pl: 6 }}>
            <TextField
              fullWidth
              id='comments'
              name='comments'
              placeholder='Escribe comentarios adicionales (opcional)...'
              value={comments}
              onChange={handleCommentsChange}
              variant='outlined'
              multiline
              minRows={2}
              size='small'
            />
          </Box>
        </Box>
        <Box sx={{ borderBottom: '1px solid #e0e0e0', mb: 2 }} />

        {/* Sección 4: Archivo */}
        <Box sx={{ mb: 1 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
            <SectionNumber number={4} />
            <Typography variant='subtitle1' sx={{ color: '#004bb1', fontWeight: 'bold', fontSize: '0.95rem' }}>
              Archivo
            </Typography>
          </Box>
          <Box sx={{ pl: 6 }}>
            {/* Descargar template */}
            <Box sx={{ mb: 1, p: 2, bgcolor: '#f5f5f5', borderRadius: 1, display: 'flex', gap: 2, alignItems: 'center' }}>
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: 32, height: 32, borderRadius: '50%', bgcolor: '#fff', border: '1px solid #ccc' }}>
                <Typography variant='body2' sx={{ fontWeight: 'bold' }}>1</Typography>
              </Box>
              <Box sx={{ flex: 1 }}>
                <Typography variant='body2' sx={{ fontWeight: '500' }}>
                  Descargar template
                </Typography>
                <Typography variant='caption' color='textSecondary'>
                  Usa la plantilla para completar los productos y sus cantidades.
                </Typography>
              </Box>
              {requestLabelState.status === Status.Loading ? (
                <Loading />
              ) : (
                <Button
                  variant='outlined'
                  size='small'
                  onClick={handleDownloadTemplate}
                  startIcon={<DownloadIcon />}
                  sx={{ width: '200px', fontSize: '0.75rem' }}
                >
                  Descargar Tamplate
                </Button>
              )}
            </Box>

            {/* Cargar archivo */}
            <Box sx={{ p: 2, bgcolor: '#f5f5f5', borderRadius: 1, display: 'flex', gap: 2, alignItems: 'center' }}>
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: 32, height: 32, borderRadius: '50%', bgcolor: '#fff', border: '1px solid #ccc' }}>
                <Typography variant='body2' sx={{ fontWeight: 'bold' }}>2</Typography>
              </Box>
              <Box sx={{ flex: 1 }}>
                <Typography variant='body2' sx={{ fontWeight: '500' }}>
                  Cargar archivo
                </Typography>
                <Typography variant='caption' color='textSecondary'>
                  Sube el archivo Excel completado para continuar.
                </Typography>
                {selectedFiles && selectedFiles.length > 0 && (
                  <Typography variant='caption' display='block' sx={{ mt: 1, color: '#004bb1' }}>
                    ✓ {selectedFiles[0].name}
                  </Typography>
                )}
              </Box>
              <label htmlFor='btn-upload' style={{ display: 'flex' }}>
                <input
                  id='btn-upload'
                  name='btn-upload'
                  style={{ display: 'none' }}
                  type='file'
                  onChange={handleSelectFile}
                  accept='.xls,.xlsx'
                />
                <Button
                  variant='outlined'
                  component='span'
                  size='small'
                  startIcon={<FileUploadIcon />}
                  sx={{ width: '200px', fontSize: '0.75rem', display: 'flex', alignItems: 'center', gap: 1 }}
                >
                  Seleccionar Archivo
                </Button>
              </label>
            </Box>
          </Box>
        </Box>

        {/* Progress bar */}
        {currentFile && (
          <Box sx={{ pl: 6, mt: 1 }}>
            <BorderLinearProgress variant='determinate' value={progress} />
            <Typography variant='caption' color='textSecondary' sx={{ display: 'block', textAlign: 'right', mt: 1 }}>
              {progress}%
            </Typography>
          </Box>
        )}
      </Box>

      {/* Botones de acción */}
      <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end', pt: 1, borderTop: '1px solid #e0e0e0' }}>
        <Button
          variant='outlined'
          color='primary'
          onClick={handleCloseModal}
        >
          CERRAR
        </Button>
        <Button
          variant='contained'
          color='primary'
          disabled={validateButtonLoad()}
          onClick={handleSubmit}
        >
          CARGAR
        </Button>
      </Box>
    </Fragment>
  )
}
